import styled, { css } from 'styled-components'
import { desktopBreakpoint, mobileBreakpoint, wideScreenBreakpoint } from 'react-components'
import { BaseTraumTagLabel, BaseFreeCancellationContainer } from '../card-shared-styles'

export const TraumTagLabel = styled(BaseTraumTagLabel)`
    white-space: nowrap;
`

export const FreeCancellationContainer = styled(BaseFreeCancellationContainer)`
    margin-top: 0.5rem;
`

export const GridCardContainer = styled.div<{ $isObjectOverview?: boolean }>(
    ({ theme, $isObjectOverview }) => css`
        display: flex;
        flex-direction: column;
        height: 100%;
        cursor: pointer;

        background-color: ${theme.colors.white};
        box-shadow:
            0px 1px 5px 0px #00000014,
            0px 2px 1px 0px #0000000a,
            0px 1px 2px 0px #0000000f;
        border-radius: 1rem;

        ${$isObjectOverview &&
        css`
            margin-bottom: ${theme.spacing.medium};
        `}
    `,
)

export const FeatureIconsContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing.xxSmall};
    margin-bottom: ${({ theme }) => theme.spacing.xxSmall};
    width: 100%;
    overflow: hidden;
`

export const CTAButton = styled.button`
    width: 100%;
    padding: 12px 16px;
    border-radius: 12px;
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1rem;
    cursor: pointer;
    text-align: center;
    border: 1px solid transparent;

    background-color: ${({ theme }) => theme.colors.tfwYellow};
    color: ${({ theme }) => theme.colors.tfwBlack99};

    &:hover {
        background-color: ${({ theme }) => theme.colors.tfwYellowHover};
    }

    &:active {
        transform: translateY(1px);
    }

    /*
    In grid view on desktop, the button breaks due to insufficient width.
    A proper fix will be implemented in the future.
    */
    @media only screen and (min-width: ${desktopBreakpoint.min}px) and (max-width: ${wideScreenBreakpoint.min}px) {
        font-size: ${({ theme }) => theme.typography.font.size.xSmall};
        padding: ${({ theme }) => theme.spacing.small};
    }
`

export const BottomRow = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: auto;
`

export const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0.5rem;
    gap: 0.25rem;
`

export const ButtonWrapper = styled.div`
    max-width: 140px;
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        max-width: 90px;
    }
`

export const ImageContainer = styled.div(
    () => css`
        position: relative;
        overflow: hidden;
        border-radius: 1rem 1rem 0 0;
        aspect-ratio: 3 / 2;
    `,
)

export const CardContent = styled.div<{ $hasBottomTags?: boolean }>(
    ({ $hasBottomTags }) => css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        padding: 0.75rem 1rem;
        border-radius: 1rem;

        ${$hasBottomTags &&
        css`
            background: linear-gradient(190.38deg, #ffffff 72.45%, #eee3ff 100%);
        `}
    `,
)

export const CardTopSection = styled.div``

export const BookingHighlights = styled.div`
    display: flex;
    margin-top: 0.5rem;
    gap: 0.25rem 1rem;
    flex-wrap: wrap;
`

export const TooltipContainer = styled.div`
    position: absolute;
    bottom: 150%;
    left: 70%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: normal;
    opacity: 0;
    visibility: hidden;
    transition:
        opacity 0.2s,
        visibility 0.2s;
    z-index: 10;
    width: max-content;
    max-width: 200px;
    text-align: center;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #333 transparent transparent transparent;
    }
`

export const DTVContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    &:hover ${TooltipContainer} {
        opacity: 1;
        visibility: visible;
    }
`

export const ImageSkeleton = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    z-index: 1;
`

export const CardBottomContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: flex-end;
    gap: 0.5rem;
`

export const BottomContainerWrapper = styled.div`
    width: 100%;
`

export const CtaPriceContainer = styled.div`
    display: flex;
`

export const BottomTraumTagContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0.75rem;
`

export const LocationRatingContainer = styled.div(
    () => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
)

export const RatingText = styled.span`
    color: #282828;
`

export const RatingCount = styled.span`
    margin-left: 0.25rem;
    color: #6c6c6c;
`

export const PropertyTitle = styled.h3(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5rem;
        color: #282828;
        margin-top: 2px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `,
)

export const PropertyDescription = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 0.875rem;
        color: #282828;
        margin-top: 2px;
        line-height: 1.375rem;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
)

export const PriceContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5rem;
        margin-top: 0.25rem;
    `,
)

export const SlasherPrice = styled.div(
    () => css`
        display: flex;
        position: relative;
        font-weight: 500;
        color: #aaaaaa;
        margin-right: 4px;
        text-decoration: line-through;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) and (max-width: ${wideScreenBreakpoint.min}px) {
            font-size: 1rem;
            line-height: 1.5rem;
        }
    `,
)

export const PersonDetails = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1rem;
        color: #6c6c6c;
    `,
)

const fadeIn = css`
    @keyframes fadeIn {
        0% {
            opacity: 0;
            transform: translateY(-6px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
`

export const TopTraumTagPill = styled.div<{ $showCheckbox?: boolean }>(
    ({ theme, $showCheckbox }) => css`
        ${fadeIn}
        display: flex;
        align-items: center;
        gap: 0.25rem;
        position: absolute;
        top: 0.75rem;
        left: ${$showCheckbox ? '3rem' : '0.5rem'};
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
        color: ${theme.colors.tfwPurple};
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(4px);
        font-size: 0.75rem;
        font-weight: 500;
        animation: fadeIn 0.8s ease-out;
    `,
)

export const VirtualTourWrapper = styled.div<{ shouldShowRating: boolean }>(
    ({ shouldShowRating }) => css`
        position: absolute;
        bottom: ${shouldShowRating ? '2rem' : '0.5rem'};
        left: 0.5rem;
    `,
)

export const RatingBadge = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0.8rem;
        min-width: 5.5rem;
        background-color: white;
        padding: 0.25rem 0.5rem 0;
        font: 400 0.875rem / 1.375rem ${theme.typography.font.family.lato};
        border-radius: 0.6rem 0.6rem 0 0;
        justify-content: center;

        &::before {
            content: '';
            position: absolute;
            bottom: 0;
            left: -0.75rem;
            width: 0.8rem;
            height: 0.75rem;
            background: radial-gradient(circle at 0 0, transparent 0.75rem, white 0.75rem);
        }

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            right: -0.75rem;
            width: 0.8rem;
            height: 0.75rem;
            background: radial-gradient(circle at 100% 0, transparent 0.75rem, white 0.75rem);
        }
    `,
)

export const OfferBadge = styled.div(
    () => css`
        display: flex;
        align-items: center;
        width: fit-content;
        min-width: 8.4375rem;
        background: linear-gradient(90deg, #d2faea 0%, #ffffff 100%);
        padding: 0.25rem 0.5rem;
        border-radius: 12px;
        margin-top: 0.5rem;
    `,
)

export const OfferText = styled.span`
    color: #0d7c4f;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 400;
`

export const FreeCancellationText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1rem;
        color: #282828;
    `,
)

export const StyledCarouselProvider = styled.div`
    position: relative;
    width: 100%;
    border-radius: 1rem;
    overflow: hidden;

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        border-radius: 0.5rem;
    }
`

export const StyledSlider = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`

export const CarouselIcon = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
